import { render, staticRenderFns } from "./PrivacyAgreement.vue?vue&type=template&id=00d9ec9a&scoped=true&"
import script from "./PrivacyAgreement.vue?vue&type=script&lang=js&"
export * from "./PrivacyAgreement.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyAgreement.vue?vue&type=style&index=0&id=00d9ec9a&lang=scss&scoped=true&"
import style1 from "./PrivacyAgreement.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d9ec9a",
  null
  
)

export default component.exports